import React from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  Backdrop,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CloseSharp } from "@mui/icons-material";
import recipienticon from "../../assets/images/recipient-name.png";
import recipientemailicon from "../../assets/images/email-icon-pod.png";
import deliverydateicon from "../../assets/images/delivery-date-pod.png";
import deliverytimeicon from "../../assets/images/deliverytime-pod-icon.png";
import podloc1icon from "../../assets/images/pod-location1-icon.png";
import podloc2icon from "../../assets/images/pod-loc2-icon.png";
import { toLocalTime } from "../../helper/functions";
import PodMap from "../../components/maps/PodMap";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backdropFilter: "blur(2px)", // Adjust blur strength as needed
  },
  dialogPaper: {
    borderRadius: "0", // Set border radius to 0
    border: "1px solid #000",
  },
  textFieldRoot: {
    "& .MuiInputLabel-root": {
      color: "#8D8D8E !important", // Adding !important to ensure the color overrides
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Initial outlined border color
      },
      "&:hover fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Change outlined border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Change outlined border color when focused
      },
    },
  },
}));
const PodModal = ({ onClose, open, order, dropoff }) => {
  const classes = useStyles();

  return (
    <>
      <Backdrop className={classes.backdrop} open={open} />
      <Dialog
        open={open}
        onClose={onClose}
        sx={{ mx: "auto" }}
        // classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent
          sx={{
            padding: "15px",
            width: "364px",
            backgroundColor: "white",
            position: "relative",
            borderRadius: "12px",
          }}
        >
          <CloseSharp
            onClick={() => onClose()}
            sx={{
              width: "15px",
              height: "15px",
              color: "black",
              right: "14px",
              top: "13px",
              position: "absolute",
              cursor: "pointer",
            }}
          />
          <Box sx={{ color: "black" }}>
            <Typography
              fontSize={"14px"}
              fontWeight={600}
              textAlign={"center"}
              mt={"20px"}
            >
              Delivered Details
            </Typography>
            <Box display={"flex"} flexDirection={"column"} gap="10px" mt="18px">
              {dropoff?.inHandDelivery && (
                <>
                  <Box display={"flex"} flexDirection={"column"} gap="10px">
                    <Typography fontSize={"12px"}>Recipient's Name</Typography>
                    <Box sx={{ width: "100%", position: "relative" }}>
                      <img
                        src={recipienticon}
                        style={{
                          position: "absolute",
                          top: "7px",
                          left: "7px",
                        }}
                        alt=""
                      />
                      <input
                        type="text"
                        placeholder="Recipient’s name"
                        value={dropoff?.recipientName || "NA"}
                        disabled={true}
                        className="white-disable-color"
                        style={{
                          height: "36px",
                          borderRadius: "12px",
                          padding: "10px",
                          paddingLeft: "32px",
                          border: "1px solid #CECECE",
                          outline: "none",
                          width: "100%",
                        }}
                      />
                    </Box>
                  </Box>
                  <Box display={"flex"} flexDirection={"column"} gap="10px">
                    <Typography fontSize={"12px"}>Recipient's Email</Typography>
                    <Box sx={{ width: "100%", position: "relative" }}>
                      <img
                        src={recipientemailicon}
                        style={{
                          position: "absolute",
                          top: "7px",
                          left: "7px",
                        }}
                        alt=""
                      />
                      <input
                        type="text"
                        placeholder="Recipient’s Email"
                        value={dropoff?.recipientEmail || "NA"}
                        disabled={true}
                        className="white-disable-color"
                        style={{
                          height: "36px",
                          borderRadius: "12px",
                          width: "100%",
                          padding: "10px",
                          paddingLeft: "32px",
                          border: "1px solid #CECECE",
                          outline: "none",
                        }}
                      />
                    </Box>
                  </Box>
                </>
              )}
              <Box display={"flex"} alignItems="center" gap="10px">
                <Box display={"flex"} flexDirection={"column"} gap="10px">
                  <Typography fontSize={"12px"}>Delivery date</Typography>
                  <Box sx={{ width: "100%", position: "relative" }}>
                    <img
                      src={deliverydateicon}
                      style={{ position: "absolute", top: "7px", left: "7px" }}
                      alt=""
                    />
                    <input
                      type="text"
                      placeholder="Delivery date"
                      disabled={true}
                      className="white-disable-color"
                      value={toLocalTime(order?.deliveryDate, "DD MMM YYYY")}
                      style={{
                        height: "36px",
                        borderRadius: "12px",
                        width: "100%",
                        padding: "10px",
                        paddingLeft: "32px",
                        border: "1px solid #CECECE",
                        outline: "none",
                      }}
                    />
                  </Box>
                </Box>{" "}
                <Box display={"flex"} flexDirection={"column"} gap="10px">
                  <Typography fontSize={"12px"}>Delivery Time</Typography>
                  <Box sx={{ width: "100%", position: "relative" }}>
                    <img
                      src={deliverytimeicon}
                      style={{ position: "absolute", top: "7px", left: "7px" }}
                      alt=""
                    />
                    <input
                      type="text"
                      placeholder="Delivery time"
                      disabled={true}
                      className="white-disable-color"
                      value={toLocalTime(order?.deliveryTime, "h:mm A")}
                      style={{
                        height: "36px",
                        width: "100%",
                        borderRadius: "12px",
                        padding: "10px",
                        paddingLeft: "32px",
                        border: "1px solid #CECECE",
                        outline: "none",
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Typography fontSize={"10px"} textAlign={"center"}>
                Note : All Times & Dates are displayed in your local time zone.
              </Typography>
              <Box display={"flex"} flexDirection={"column"} gap="10px">
                <Typography fontSize={"12px"}>
                  Captured Location : Address
                </Typography>
                <Box sx={{ width: "100%", position: "relative" }}>
                  <img
                    src={podloc1icon}
                    style={{ position: "absolute", top: "7px", left: "7px" }}
                    alt=""
                  />
                  <input
                    type="text"
                    placeholder="Delivery time"
                    disabled={true}
                    className="white-disable-color"
                    value={dropoff?.capturedLocation?.address || "NA"}
                    style={{
                      height: "36px",
                      width: "100%",
                      borderRadius: "12px",
                      padding: "10px",
                      paddingLeft: "32px",
                      border: "1px solid #CECECE",
                      outline: "none",
                    }}
                  />
                </Box>
              </Box>
              <PodMap
                address={dropoff?.capturedLocation?.address || "NA"}
                position={[
                  Number(dropoff?.capturedLocation?.latitude),
                  Number(dropoff?.capturedLocation?.longitude),
                ]}
              />
              <Typography
                color="#C80707"
                fontSize={"10px"}
                textAlign={"center"}
              >
                Disclaimer: Current Location is accurate to 30 meters.
              </Typography>
              <Box display={"flex"} flexDirection={"column"} gap="10px">
                <Typography fontSize={"12px"}>
                  Captured Location : Latitude & Longitude{" "}
                </Typography>
                <Box sx={{ width: "100%", position: "relative" }}>
                  <img
                    src={podloc2icon}
                    style={{ position: "absolute", top: "8px", left: "7px" }}
                    alt=""
                  />
                  <input
                    type="text"
                    placeholder="Delivery time"
                    disabled={true}
                    className="white-disable-color"
                    value={`${dropoff?.capturedLocation?.latitude}, ${dropoff?.capturedLocation?.longitude}`}
                    style={{
                      height: "36px",
                      width: "100%",
                      borderRadius: "12px",
                      padding: "10px",
                      paddingLeft: "32px",
                      border: "1px solid #CECECE",
                      outline: "none",
                    }}
                  />
                </Box>
              </Box>
              <Box display={"flex"} alignItems={"center"} gap="33px">
                <Box
                  sx={{ width: "100%" }}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  gap="15px"
                >
                  <Box
                    sx={{
                      width: "100%",
                      height: "115px",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: dropoff?.dropoffEvidenceImage
                        ? "transparent"
                        : "#673C8E59",
                    }}
                  >
                    {dropoff?.dropoffEvidenceImage ? (
                      <img
                        src={dropoff?.dropoffEvidenceImage}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          borderRadius: "12px",
                        }}
                        alt=""
                      />
                    ) : (
                      <Typography fontSize={"12px"} color={"#cd2b2b"}>
                        No Proof Available!
                      </Typography>
                    )}
                  </Box>
                  <Typography
                    color={"#673C8E"}
                    fontSize={"12px"}
                    fontWeight={600}
                  >
                    Proof Of Delivery
                  </Typography>
                </Box>
                {dropoff?.inHandDelivery && (
                  <Box
                    sx={{ width: "100%" }}
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                    gap="15px"
                  >
                    <Box
                      sx={{
                        width: "100%",
                        height: "115px",
                        borderRadius: "12px",
                        backgroundColor: dropoff?.recipientSignature
                          ? "transparent"
                          : "#673C8E59",
                      }}
                    >
                      {dropoff?.recipientSignature && (
                        <img
                          src={dropoff?.recipientSignature}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            borderRadius: "12px",
                          }}
                          alt=""
                        />
                      )}
                    </Box>
                    <Typography
                      color={"#673C8E"}
                      fontSize={"12px"}
                      fontWeight={600}
                    >
                      Signature{" "}
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box display={"flex"} flexDirection={"column"} gap="10px">
                <Typography
                  fontSize={"12px"}
                  fontWeight={700}
                  textAlign={"center"}
                >
                  Delivery/Dropoff Notes{" "}
                </Typography>
                <textarea
                  className="white-disable-color"
                  value={dropoff?.drivernote || "NA"}
                  disabled={true}
                  style={{
                    height: "136px",
                    width: "100%",
                    border: "1px solid #CECECE",
                    borderRadius: "12px",
                    padding: "10px",
                    outline: "none",
                    resize: "none",
                  }}
                />
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PodModal;
